import React from 'react';
import { Camera, Star, Car, Award } from 'lucide-react';

const DriverProfileHeader = ({ profile, onEditPhoto }) => {
  const initials = profile?.name
    ? profile?.name?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2)
    : 'D';

  const rating = profile?.rating ? parseFloat(profile?.rating)?.toFixed(1) : '5.0';

  return (
    <div className="bg-gradient-to-br from-[#1a365d] to-[#2d5a87] rounded-2xl p-6 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-40 h-40 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#ffd700]/10 rounded-full translate-y-1/2 -translate-x-1/2" />
      <div className="relative flex items-start gap-5">
        <div className="relative flex-shrink-0">
          {profile?.avatarUrl ? (
            <img
              src={profile?.avatarUrl}
              alt={`${profile?.name || 'Driver'} profile photo`}
              className="w-20 h-20 rounded-2xl object-cover border-2 border-[#ffd700]/50"
            />
          ) : (
            <div className="w-20 h-20 rounded-2xl bg-[#ffd700]/20 border-2 border-[#ffd700]/50 flex items-center justify-center">
              <span className="text-2xl font-bold text-[#ffd700]">{initials}</span>
            </div>
          )}
          <button
            onClick={onEditPhoto}
            className="absolute -bottom-1 -right-1 w-7 h-7 bg-[#ffd700] rounded-lg flex items-center justify-center hover:bg-[#fbbf24] transition-colors"
          >
            <Camera className="w-3.5 h-3.5 text-[#1a365d]" />
          </button>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h2 className="text-xl font-bold">{profile?.name || 'OnTheGo Driver'}</h2>
            {profile?.isVerified && (
              <span className="px-2 py-0.5 bg-[#ffd700] text-[#1a365d] text-xs font-bold rounded-full">Verified</span>
            )}
          </div>
          <p className="text-white/70 text-sm mt-0.5">{profile?.email || ''}</p>
          <div className="flex items-center gap-4 mt-3">
            <div className="flex items-center gap-1.5">
              <Star className="w-4 h-4 text-[#ffd700] fill-[#ffd700]" />
              <span className="font-bold text-[#ffd700]">{rating}</span>
              <span className="text-white/50 text-xs">rating</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Award className="w-4 h-4 text-white/60" />
              <span className="font-bold">{profile?.totalTrips ?? 0}</span>
              <span className="text-white/50 text-xs">trips</span>
            </div>
          </div>
          {(profile?.vehicleName || profile?.vehicleType) && (
            <div className="flex items-center gap-1.5 mt-2">
              <Car className="w-3.5 h-3.5 text-white/50" />
              <span className="text-xs text-white/60">
                {[profile?.vehicleName, profile?.vehicleColor, profile?.licensePlate]?.filter(Boolean)?.join(' · ')}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DriverProfileHeader;
